import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

declare global {
  interface Window {
    FRONTEND_CONFIG: {
      API_BASE: string;
      WS_BASE: string;
      APP_VERSION: string;
      GIT_SHA: string;
      BUILD_TIME: string;
      BANNER_COLOR_START: string;
      BANNER_COLOR_END: string;
      ENVIRONMENT?: string;
      DEPLOYED_AT?: string;
    };
  }
}

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
